import React, { FC } from 'react';
import { IFileThumbnail } from '../../types';

export const UndefinedThumbnail: FC<IFileThumbnail> = ({ saveRef }) => <div ref={saveRef} />;
